import type { ReactNode } from 'react'
import { useState } from 'react'
import { ApplicantModal } from '~/components/Scopes/Applicants/ApplicantModal/ApplicantModal'
import type { ApplicantModalType } from '~/types/global'
import { ApplicantModalContext } from '~/utils/contextes'

export function ApplicantModalProvider({ children }: { children: ReactNode }) {
  const [applicantCollection, setApplicantCollection] = useState<
    ApplicantModalType[]
  >([])
  const [applicantCurrentId, setApplicantCurrentId] = useState<number | null>(
    null
  )

  return (
    <ApplicantModalContext.Provider
      value={{
        applicantCollection,
        setApplicantCollection,
        applicantCurrentId,
        setApplicantCurrentId
      }}
    >
      {children}
      {applicantCurrentId && (
        <ApplicantModal
          defaultApplicantId={applicantCurrentId}
          collection={applicantCollection}
          onClose={() => setApplicantCurrentId(null)}
        />
      )}
    </ApplicantModalContext.Provider>
  )
}
